import { Typography } from "@mui/material";

import type { ModelInfo } from "../../../model/modelInfo";
import { PanelSection } from "../PanelSection/PanelSection";
import "./ModelDetails.css";

export function ModelDetails({ fileName, info }: { fileName: string; info: ModelInfo }) {
  const { x, y, z } = info.size;
  const details = [
    ["Triangles", info.triangles.toLocaleString()],
    ["Textures", String(info.textures)],
    ["Size", `${x.toFixed(2)} x ${y.toFixed(2)} x ${z.toFixed(2)} m`]
  ];

  return (
    <PanelSection title="Model">
      <Typography variant="subtitle1">
        {fileName}
      </Typography>
      {details.map(([label, value]) => (
        <div key={label} className="model-details-row">
          <Typography variant="body2" color="text.secondary">
            {label}
          </Typography>
          <Typography variant="body2">{value}</Typography>
        </div>
      ))}
    </PanelSection>
  );
}
